import { render, staticRenderFns } from "./GaokaoRealExam.vue?vue&type=template&id=35261b3e&scoped=true&"
import script from "./GaokaoRealExam.vue?vue&type=script&lang=js&"
export * from "./GaokaoRealExam.vue?vue&type=script&lang=js&"
import style0 from "./GaokaoRealExam.vue?vue&type=style&index=0&id=35261b3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35261b3e",
  null
  
)

export default component.exports